"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _react2 = require("@emotion/react");
var _utils = require("../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultProps = {
  headers: [],
  tabs: [],
  styles: '',
  className: '',
  defaultValue: 0,
  onChangeTabs() {}
};
function Tabs(props) {
  const {
    headers,
    tabs,
    styles,
    className,
    defaultValue,
    onChangeTabs
  } = _objectSpread(_objectSpread({}, defaultProps), props);
  const [selectedTab, setSelectedTab] = (0, _react.useState)(defaultValue);
  const {
    colors
  } = (0, _react2.useTheme)();
  const onChange = index => {
    setSelectedTab(index);
    onChangeTabs === null || onChangeTabs === void 0 || onChangeTabs(index);
  };
  return /*#__PURE__*/_react.default.createElement(Container, {
    styles: styles,
    className: className
  }, /*#__PURE__*/_react.default.createElement(Headers, null, headers === null || headers === void 0 ? void 0 : headers.map((children, index) => {
    const isActiveTab = selectedTab === index;
    const isDisabledTab = /*#__PURE__*/_react.default.isValidElement(children) && children.props.disabled;
    return /*#__PURE__*/_react.default.createElement(HeaderTab, {
      key: index,
      isActive: isActiveTab,
      isDisabledTab: isDisabledTab,
      onClick: () => isDisabledTab ? null : onChange(index),
      "data-role": "tab-header",
      "data-active": isActiveTab
    }, /*#__PURE__*/_react.default.isValidElement(children) && /*#__PURE__*/_react.default.cloneElement(children, {
      color: isActiveTab ? colors.MAIN.INFO : colors.FONT.DESCRIPTION,
      'data-active': isActiveTab,
      'aria-disabled': isDisabledTab
    }));
  })), /*#__PURE__*/_react.default.createElement(Row, null, tabs === null || tabs === void 0 ? void 0 : tabs[selectedTab]));
}
const Container = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n\n  ", "\n"])), _ref => {
  let {
    styles
  } = _ref;
  return styles;
});
const Row = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n"])));
const Headers = _styled.default.ul(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
const HeaderTab = _styled.default.li(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  flex-basis: 100%;\n  list-style-type: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 50px;\n  border-bottom: 1px solid\n    ", ";\n\n  ", "\n"])), _ref2 => {
  let {
    theme,
    isActive
  } = _ref2;
  return isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.MAIN.INFO : (0, _utils.hexToRGBA)(theme.colors.FONT.DESCRIPTION, 0.3);
}, _ref3 => {
  let {
    isDisabledTab
  } = _ref3;
  let styles = "";
  if (isDisabledTab) {
    styles += "\n          opacity: 0.4;\n          cursor: not-allowed;\n        ";
  }
  return styles;
});
var _default = exports.default = Tabs;